import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/goodreads': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M299.9 191.2C305 228.5 295.2 270.2 264 291.9 241.7 307.4 211.2 306 193.2 297.6 156.1 280.3 143.7 239 146.4 200.4 150.7 139.5 187.3 112.5 221.7 112.9 268.6 112.7 293.5 144.7 299.9 191.2zM448 88V424C448 454.9 422.9 480 392 480H56C25.1 480 0 454.9 0 424V88C0 57.1 25.1 32 56 32H392C422.9 32 448 57.1 448 88zM330 313.2S329.9 279.2 329.9 95.9H300.9V136.2C300.1 136.5 299.7 135.7 299.3 135 289.7 114.3 263.4 88.7 223.3 89 171.4 89.4 136.1 120.2 122.7 166.8 118.4 181.7 116.9 196.9 117.2 212.4 118.9 290.3 162.3 330.2 229.6 327.6 258.5 326.5 284.1 310.6 298.6 282.4 299.1 281.4 299.7 280.5 300.3 279.5 300.5 279.6 300.7 279.6 300.9 279.7 301.2 283.5 301.1 310.4 301 314.2 300.8 329 299 343.7 293.8 357.7 286 378.7 271.5 392.4 249.3 397.2 231.5 401.1 213.7 401 196.1 396 174.6 389.9 159.6 377 155 354.2 154.7 352.6 153.7 352.9 152.7 352.9H125.9C126.7 363.5 129.1 373.2 134.4 382.1 158.6 422.6 217.1 430.6 262.6 419.5 312.5 407.2 329.9 364.6 330 313.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/goodreads.js
// module id = YrDg
// module chunks = 144